import { Folder, Hash, MessageSquare, Users, Volume2 } from 'lucide-react'
import { avatarUrl } from '@/lib/avatar'
import type { Candidate } from '@/lib/commands'
import { ChannelType } from '@/types/api'
import { Avatar } from '../Avatar'
import styles from './CandidateIcon.module.css'

const colorOf = (id: string) => `hsl(${Number(id.slice(-4)) % 360} 55% 50%)`

/** Значок строки выбора: аватар участника, значок роли её цветом, значок канала по типу. */
export function CandidateIcon({ c, size = 22 }: { c: Candidate; size?: number }) {
  if (c.kind === 'user') {
    const id = String(c.value)
    return <Avatar initial={c.label.slice(0, 1).toUpperCase()} color={colorOf(id)} size={size} src={avatarUrl(id, c.avatar)} />
  }
  if (c.kind === 'role') {
    return (
      <span className={styles.icon} style={{ color: c.color ?? 'var(--text-muted)' }} aria-hidden="true">
        <Users size={16} />
      </span>
    )
  }
  if (c.kind === 'channel') {
    const Icon =
      c.channelType === ChannelType.GuildVoice || c.channelType === ChannelType.GuildStageVoice
        ? Volume2
        : c.channelType === ChannelType.GuildCategory
          ? Folder
          : c.channelType === ChannelType.PublicThread
            ? MessageSquare
            : Hash
    return (
      <span className={styles.icon} aria-hidden="true">
        <Icon size={16} />
      </span>
    )
  }
  return null
}
